import styled from 'styled-components/macro';

export const DragZone = styled.div<{ active?: boolean }>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  & > * {
    ${(props) => props.active && `border-style: dashed`};
  }
`;
